import React, { useState, useEffect } from 'react';
// PROPTYPES
import PropTypes from 'prop-types';
import {
  Skeleton,
  Empty,
  Collapse,
  Icon,
  Typography,
  Upload,
  message,
} from 'antd';
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  MoreOutlined,
} from '@ant-design/icons';
import {
  WhiteSpace,
  ActivityIndicator,
  Popover,
  Carousel,
  WingBlank,
} from 'antd-mobile';

import { FormattedMessage } from 'react-intl';
import * as way from 'app/libs/core/PubSubWays';
import { publish } from 'app/libs/core/PubSub';
import { DownloadTourGpsProps } from '../../../constants/PropType/propTypesDownloadTourGps';
import { fullDataProps } from '../../../constants/PropType/propTypesFullData';
import { MapDataProps } from '../../../constants/PropType/propTypesMapData';

// CSS
import '../FullTourView/fullTourViewMobile.css';
import './place.mobile.css';
// ANTD

// Slider
import 'react-image-gallery/styles/css/image-gallery.css';

// Component
import PlaceTitle from '../../Desctop/Places/Components/title';
import PlacePoint from '../../Desctop/Places/Components/point';
import MainButton from '../../Desctop/Places/Components/mainButton';
import SavePlace from '../../Desctop/Places/Components/save';
import PlaceAction from '../../Desctop/Places/Components/action';

// UTILITY

import { getCustomId } from '../../../libs/core/Unique';

const { Panel } = Collapse;
const { Item } = Popover;

const updatePointMedia = (pointId, images) => {
  publish(way.DRIVE_PREVIEW_POINT_UPDATE, { id: pointId, images });
};

const addNewPointPicture = (file, props) => {
  props.tourData.points.forEach((item) => {
    if (item.id === props.fullData.dataPoint.id) {
      item.images.unshift(file);
      updatePointMedia(props.fullData.dataPoint.id, item.images);
    }
  });
};
// const deletePointPictures = (file, props) => {
//   props.tourData.points.map((item) => {
//     if (item.id === props.fullData.dataPoint.id) {
//       item.images.splice(item.images.indexOf(file), 1);
//       updatePointMedia(props.fullData.dataPoint.id, item.images);
//     }
//   });
// };

const addNewImages = (data, props, imgMain, type) => {
  const arr = [];
  imgMain.map((img) => {
    arr.push({ ...img, uid: getCustomId(), thumbUrl: img.path });
  });

  return (
    <Upload
      name="file"
      listType="picture-card"
      multiple
      defaultFileList={arr}
      showUploadList={{
        showPreviewIcon: false,
        showDownloadIcon: false,
        showRemoveIcon: true,
      }}
      action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
      onChange={(info) => {
        const { status } = info.file;
        console.log(info.file);
        if (status === 'done') {
          if (type === 'main') {
            props.uploadImage(info);
          } else {
            addNewPointPicture(info.file, props);
          }
          message.success(`${info.file.name} file uploaded successfully`);
        } else if (status === 'error') {
          message.error(`${info.file.name} file upload failed`);
        }
      }}
    >
      <div>
        <PlusOutlined />
        <div className="ant-upload-text">
          <FormattedMessage id="Add image" defaultMessage="Add image" />
        </div>
      </div>
    </Upload>
  );
};

const sliderMainInfo = (data) => {
  if (data.images && data.images.length > 0) {
    return (
      <WingBlank>
        <WhiteSpace />
        <Carousel
          className="space-carousel"
          frameOverflow="visible"
          cellSpacing={10}
          slideWidth={0.8}
          dots={false}
        >
          {data.images.map((val, index) => {
            return (
              <img
                src={val.fullpath ? val.fullpath : val.thumbUrl}
                alt={`${val.fullpath}`}
                key={`${val.fullpath}`}
                style={{
                  width: '100%',
                  verticalAlign: 'top',
                  objectFit: 'cover',
                  height: 150,
                }}
                onLoad={() => {
                  // fire window resize event to change height
                  window.dispatchEvent(new Event('resize'));
                }}
              />
            );
          })}
        </Carousel>
        <WhiteSpace />
      </WingBlank>
    );
  }
  return (
    <div className="sliderBottomEmpty">
      <Empty description="No Image" />
    </div>
  );
};

const mainInfo = (props, imgMain, setImageMain) => {
  const { data, fetching } = props.placesData;

  return (
    <div className="mainInfoMobile">
      {fetching ? (
        <div
          style={{
            height: 80,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ActivityIndicator />
        </div>
      ) : props.edit ? (
        addNewImages(data, props, imgMain, 'main')
      ) : (
        sliderMainInfo(data)
      )}
      <div className="desc">
        {fetching ? (
          <Skeleton
            active
            title={false}
            paragraph={{ rows: 5, width: '100%' }}
          />
        ) : (
          <Typography.Paragraph
            editable={
              props.edit
                ? {
                    editing: true,
                    onChange: (str) => {
                      if (str !== data.description) props.onChangeDesc(str);
                    },
                  }
                : false
            }
            ellipsis={false}
            onDoubleClick={() => props.editChoose(!props.edit)}
          >
            {data.description}
          </Typography.Paragraph>
        )}
      </div>
    </div>
  );
};

const Accord = (props, imgMain, setImageMain) => {
  const customPanelStyle = {
    background: '#fff',
    borderRadius: 4,
    marginBottom: 10,
    border: '1px solid ligthgray',
    overflow: 'hidden',
    boxShadow: '0 0 3px rgba(0, 0, 0, 0.2)',
  };
  return (
    <>
      <Collapse
        accordion
        expandIconPosition="right"
        defaultActiveKey={['1']}
        bordered={false}
        style={{ backgroundColor: '#f5f5f5' }}
      >
        <Panel header="Main Info" key="1" style={customPanelStyle}>
          {mainInfo(props, imgMain, setImageMain)}
        </Panel>
        <WhiteSpace
          style={{ backgroundColor: '#f5f5f5', pointerEvents: 'all' }}
          onTouchStart={(e) => onMouseOverHandler2(e)}
        />
        <Panel header="Options" key="2" style={customPanelStyle}>
          <PlaceAction {...props} />
        </Panel>
      </Collapse>
    </>
  );
};

const titlePopover = (props) => {
  const [visible, setVisible] = React.useState(false);

  const popoverContent = [
    hasUserPermition(props) && !props.edit ? (
      <Item
        key="4"
        value="edit"
        icon={<EditOutlined className="editImg" style={{ fontSize: 16 }} />}
      >
        Edit
      </Item>
    ) : null,
    hasUserPermition(props) ? (
      <Item
        key="5"
        value="delete"
        icon={<DeleteOutlined className="deleteImg" style={{ fontSize: 16 }} />}
      >
        Delete
      </Item>
    ) : null,
    // <Item key="6" value="bookmark" icon={props.bookmark}>
    //     Add to bookmark
    // </Item>
  ];

  const onSelect = (value) => {
    switch (value) {
      case 'edit':
        props.editChoose();
        break;

      case 'delete':
        props.deleteTourDay(props.placesData.data.id);
        break;

      case 'bookmark':
        props.chooseBookmark();
        break;
    }
    setVisible(!visible);
  };

  return hasUserPermition(props) ? (
    <Popover
      overlayClassName="fortest"
      overlayStyle={{ color: 'currentColor', width: '150px' }}
      visible={visible}
      placement="bottomRight"
      overlay={popoverContent}
      align={{
        overflow: { adjustY: 0, adjustX: 0 },
        offset: [-17, 5],
      }}
      onVisibleChange={() => setVisible(!visible)}
      onSelect={(e) => onSelect(e.props.value)}
    >
      <div
        style={{
          height: '100%',
          padding: '0 15px',
          marginRight: '-15px',
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
        }}
      >
        <MoreOutlined style={{ fontSize: 25 }} />
      </div>
    </Popover>
  ) : (
    <div onClick={() => props.chooseBookmark()}>{props.bookmark}</div>
  );
};

const Title = (props) => {
  return (
    <div className="titleMain">
      <div className="title">
        {props.placesData.fetching === true ? (
          <Skeleton paragraph={false} title={{ width: 200 }} active />
        ) : (
          <Typography.Paragraph
            editable={
              props.edit
                ? {
                    editing: true,
                    onChange: (str) => {
                      if (str !== props.title) props.onChangeTitle(str);
                    },
                  }
                : false
            }
            ellipsis
          >
            {props.placesData.data.title}
          </Typography.Paragraph>
        )}
      </div>
      {titlePopover(props)}
    </div>
  );
};

const onMouseOverHandler = (e) => {
  document.getElementById('tourFullMobileLayout').style.pointerEvents = 'none';
};

const onMouseOverHandler2 = (e) => {
  document.getElementById('tourFullMobileLayout').style.pointerEvents = 'all';
};

const hasUserPermition = (props) =>
  props.currentUserId &&
  props.tourData.user &&
  props.currentUserId == props.tourData.user.id;

const PlaceFullMobile = (props) => {
  const [imgMain, setImageMain] = useState([]);

  useEffect(() => {
    if (props.placesData.data.images) {
      setImageMain(props.placesData.data.images);
    }
  }, [props.placesData.data]);

  return (
    <div
      id="tourFullMobileLayout"
      className="tourFullMobileLayout"
      style={{ height: window.innerHeight - 45 }}
    >
      <WhiteSpace />
      <div
        style={{ pointerEvents: 'all', backgroundColor: '#f5f5f5' }}
        onTouchStart={(e) => onMouseOverHandler2(e)}
      >
        <PlaceTitle {...props} />
      </div>
      <WhiteSpace
        style={{ backgroundColor: '#f5f5f5', pointerEvents: 'all' }}
        onTouchStart={(e) => onMouseOverHandler2(e)}
      />
      <div
        className="Map"
        style={{ position: 'relative', height: 100 }}
        onTouchStart={(e) => onMouseOverHandler(e)}
      />
      <div
        className="tourFullViewButton"
        onTouchStart={(e) => onMouseOverHandler2(e)}
        style={{ pointerEvents: 'all' }}
      >
        {props.edit ? <SavePlace {...props} /> : <MainButton {...props} />}
      </div>
      {/* <WhiteSpace /> */}
      <div
        onTouchStart={(e) => onMouseOverHandler2(e)}
        style={{ pointerEvents: 'all', backgroundColor: '#f5f5f5' }}
      >
        {Accord(props, imgMain, setImageMain)}
      </div>
      {props.placesData.fetching === true ? (
        <div
          style={{
            height: 50,
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ActivityIndicator />
        </div>
      ) : (
        <div
          onTouchStart={(e) => onMouseOverHandler2(e)}
          style={{ pointerEvents: 'all', backgroundColor: '#f5f5f5', flex: 1 }}
          className={props.edit ? 'editTourMobile' : ''}
        >
          <PlacePoint {...props} />
        </div>
      )}
    </div>
  );
};

PlaceFullMobile.propTypes = {
  fullData: PropTypes.shape(fullDataProps),
  tourPointDataAction: PropTypes.func,
  viewString: PropTypes.string,
  measureString: PropTypes.string,
  desc: PropTypes.string,
  title: PropTypes.string,
  preview: PropTypes.object,
  tourType: PropTypes.func,
  bookmark: PropTypes.object,
  chooseBookmark: PropTypes.func,
  TourDownloadBasketData: PropTypes.func,
  TourDownloadCoord: PropTypes.func,
  downloadTourGps: PropTypes.shape(DownloadTourGpsProps),
  mapData: PropTypes.shape(MapDataProps),
  openModalTourDownload: PropTypes.func,
  ride: PropTypes.any,
  edit: PropTypes.bool,
  editChoose: PropTypes.func,
};

export default PlaceFullMobile;
